<script>
    import mixin from './../mixin';
    import constants from './../../constants';
    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        data() {
            return {
                constants: constants
            }
        },
        props: {
            item: Object,
            culture: {
                type: String,
                default: 'nl-NL'
            }
        }
    }
</script>

<template>
    <div :class="['banner', 'is-block', 'mb-4', item.colorThemeId, item.imageSet.length ? 'has-image' : '']">
		<div class="columns is-justify-content-space-between">
			<div class="column is-6">
				<time v-if="item.start" class="banner-date mb-5 is-block has-font-weight-medium" :datetime="item.start">
					{{ toDateStr(item.start, culture) }}
					<template v-if="item.end">
						<template v-if="toDateStr(item.start, culture) === toDateStr(item.end, culture)"> / {{ toTimeStr(item.start, culture) }} - {{ toTimeStr(item.end, culture) }}</template>
						<template v-else> - {{ toDateStr(item.end, culture) }}</template>
					</template>
				</time>
				<h3 :class="['title', 'is-2', 'has-text-weight-normal', 'has-lineheight-normal', item.imageSet.length ? 'mb-5' : '']" v-if="item.title">{{ item.title }}</h3>
                <a :href="item.detailUrl" :class="['button', 'is-rounded', 'is-warning', item.linkButtonTheme, item.linkTarget ? 'has-svg--outbound' : 'has-svg']" :target="item.linkTarget" v-if="item.imageSet.length">
                    <span>{{ item.linkTitle }}</span>
                    <span class="icon">
                        <img src="/svg/arrow.svg" alt="arrow right" width="12" height="10" loading="lazy">
                    </span>
                </a>
			</div>
			<div class="column is-5">
				<template v-if="item.imageSet.length">
                    <source-set :imageSets="item.imageSet" :class-name="['banner-image', 'has-mask', 'has-mask-'+item.imageShape, 'has-mask-'+item.imageShape+'-bordered']" alias="bannerImage_" />
				</template>
				<template v-else>
					<p class="is-size-7 mb-4" v-if="item.teaser">{{ item.teaser }}</p>
                    <a :href="item.detailUrl" :class="['button', 'is-rounded', 'is-warning', item.linkButtonTheme, item.linkTarget ? 'has-svg--outbound' : 'has-svg']" :target="item.linkTarget">
                        <span>{{ item.linkTitle }}</span>
                        <span class="icon">
                            <img src="/svg/arrow.svg" alt="arrow right" width="12" height="10" loading="lazy">
                        </span>
                    </a>
                    <img src="/svg/diamond.svg" alt="diamond" width="322" height="322" loading="lazy" class="banner-ornament banner-ornament--left">
                    <img src="/svg/cross.svg" alt="cross" width="290" height="290" loading="lazy" class="banner-ornament banner-ornament--top">
                    <img src="/svg/hexagon.svg" alt="hexagon" width="404" height="350" loading="lazy" class="banner-ornament banner-ornament--right">
				</template>
			</div>
		</div>
    </div>
</template>
